import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

type Props = {
  id: string;
  payload?: any;
  defaultMessage?: string;
};
const Translate: React.FC<Props & WrappedComponentProps> = ({
  id,
  defaultMessage,
  intl,
  payload,
}) => {
  return (
    <>
      {intl.formatMessage(
        {
          id,
          defaultMessage: defaultMessage || '',
        },
        payload
      )}
    </>
  );
};

export default injectIntl(Translate);
